import React from 'react';
import clinicalNutritionistImage from '@/assets/images/landing/who-is-it-for/clinical-nutritionist.png';
import dietitiansImage from '@/assets/images/landing/who-is-it-for/dietitians.svg';
import fitnessCoachImage from '@/assets/images/landing/who-is-it-for/fitness-coach.png';
import nutritionEducatorsImage from '@/assets/images/landing/who-is-it-for/nutrition-educators.png';
import styles from './TargetAudience.module.css';

const audienceCards = [
  {
    label: 'Nutrition Educators',
    image: nutritionEducatorsImage,
    className: styles.educatorCard
  },
  {
    label: 'Clinical Nutritionists',
    image: clinicalNutritionistImage,
    className: styles.clinicalCard
  },
  {
    label: 'Dietitians',
    image: dietitiansImage,
    className: styles.dieticianCard
  },
  {
    label: 'Fitness Coaches',
    image: fitnessCoachImage,
    className: styles.fitnessCard
  }
];

const TargetAudience = () => {
  return (
    <section id="for-who" className={styles.section}>
      <div className={styles.canvas}>
        <h2 className={styles.title}>Who is it for?</h2>

        <div className={styles.audienceGrid} aria-label="Professional audiences">
          {audienceCards.map(card => (
            <article key={card.label} className={`${styles.audienceCard} ${card.className}`}>
              <img src={card.image} alt={card.label} className={styles.audienceImage} />
              <span className={styles.labelPill}>{card.label}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
